import { useSelector } from "react-redux";
import { RootState } from "../store/Index";

/**
 * Hook that provides permission-checking utilities from the Redux auth store.
 *
 * Usage:
 *   const { hasPermission, userPermissions } = usePermissions();
 *   if (hasPermission("booking.add_booking")) { ... }
 */
export const usePermissions = () => {
  const userPermissions = useSelector(
    (state: RootState) => state.auth.user?.permissions || [],
  );

  const hasPermission = (permission: string): boolean => {
    return userPermissions.includes(permission.trim().replace(/'$/, ""));
  };

  const hasAnyPermission = (permissions: string[]): boolean => {
    return permissions.some((p) => hasPermission(p));
  };

  return { hasPermission, hasAnyPermission, userPermissions };
};
